import axios from 'axios';

// API URL from environment variable or default
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// Create axios instance with default config
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor for adding auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor for handling errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle 401 Unauthorized errors
    if (error.response && error.response.status === 401) {
      // Clear local storage and redirect to login
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth API
const authAPI = {
  login: (credentials) => api.post('/auth/login', credentials),
  register: (userData) => api.post('/auth/register', userData),
  checkAuth: () => api.get('/auth/me'),
  logout: () => api.post('/auth/logout'),
};

// Members API
const membersAPI = {
  getMembers: (params) => api.get('/members', { params }),
  getMember: (id) => api.get(`/members/${id}`),
  updateMember: (id, data) => api.put(`/members/${id}`, data),
  getMemberStats: (id) => api.get(`/stats/member/${id}`),
  exportMembers: (params) => api.get('/members/export', { 
    params, 
    responseType: 'blob' 
  }),
};

// Giveaways API
const giveawaysAPI = {
  getGiveaways: (params) => api.get('/giveaways', { params }),
  getGiveaway: (id) => api.get(`/giveaways/${id}`),
  createGiveaway: (data) => api.post('/giveaways', data),
  updateGiveaway: (id, data) => api.put(`/giveaways/${id}`, data),
  drawWinner: (id) => api.post(`/giveaways/${id}/draw`),
};

// Tickets API
const ticketsAPI = {
  getTickets: (params) => api.get('/tickets', { params }),
  getMemberTickets: (id, params) => api.get(`/tickets/member/${id}`, { params }),
  createTicket: (data) => api.post('/tickets', data),
  exportTickets: (params) => api.get('/tickets/export', { 
    params, 
    responseType: 'blob' 
  }),
};

// Stats API
const statsAPI = {
  getStats: () => api.get('/stats'),
  getMemberStats: (id) => api.get(`/stats/member/${id}`),
};

// Emails API
const emailsAPI = {
  getTemplates: () => api.get('/emails/templates'),
  getTemplateById: (id) => api.get(`/emails/templates/${id}`),
  updateTemplate: (templateData) => api.put(`/emails/templates/${templateData.id}`, templateData),
  sendTestEmail: (templateId, email) => api.post(`/emails/templates/${templateId}/test`, { email }),
  getEmailLogs: (params) => api.get('/emails/logs', { params }),
};

export default api;
export { api, authAPI, membersAPI, giveawaysAPI, ticketsAPI, statsAPI, emailsAPI };